(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();

  const reveal = (visual) => {
    if (initialized.has(visual)) return;
    initialized.add(visual);

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      visual.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, { threshold: 0.32 });

    observer.observe(visual);
  };

  const init = (scope = document) => {
    const visuals = scope.matches?.('[data-griit-event-visual]')
      ? [scope]
      : scope.querySelectorAll?.('[data-griit-event-visual]') || [];

    visuals.forEach(reveal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
